__turbopack_context__.v({
  "active": "style-module-scss-module__rQo4Oa__active",
  "component": "style-module-scss-module__rQo4Oa__component",
  "label": "style-module-scss-module__rQo4Oa__label",
  "location-option": "style-module-scss-module__rQo4Oa__location-option",
  "powered-by-apple": "style-module-scss-module__rQo4Oa__powered-by-apple",
  "powered-by-google": "style-module-scss-module__rQo4Oa__powered-by-google",
  "sale": "style-module-scss-module__rQo4Oa__sale",
  "section-title": "style-module-scss-module__rQo4Oa__section-title",
  "sold": "style-module-scss-module__rQo4Oa__sold",
  "suggested-link": "style-module-scss-module__rQo4Oa__suggested-link",
});
